import createVueComponent from '../createVueComponent';

const AlignRight = createVueComponent('AlignRightIcon', [
  ['line', { x1: '21', y1: '6', x2: '3', y2: '6' }],
  ['line', { x1: '21', y1: '12', x2: '9', y2: '12' }],
  ['line', { x1: '21', y1: '18', x2: '7', y2: '18' }],
]);

export default AlignRight;
